import React, { Component } from 'react';

class ContractSigneeStep extends Component {
	constructor(props) {
		super(props);
		this.state = {
			memberSearch: '',
			dropdownOpen: false,
		};
		this.searchRef = React.createRef();
		this.dropdownRef = React.createRef();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (e) => {
		if (
			this.dropdownRef.current &&
			!this.dropdownRef.current.contains(e.target) &&
			this.searchRef.current &&
			!this.searchRef.current.contains(e.target)
		) {
			this.setState({ dropdownOpen: false });
		}
	};

	addMember = (member) => {
		const { data, onChange } = this.props;
		const current = data.notifyTeamMembers || [];
		if (!current.includes(member._id)) {
			onChange('notifyTeamMembers', [...current, member._id]);
		}
		this.setState({ memberSearch: '', dropdownOpen: false });
	};

	removeMember = (memberId) => {
		const { data, onChange } = this.props;
		const current = data.notifyTeamMembers || [];
		onChange('notifyTeamMembers', current.filter((id) => id !== memberId));
	};

	render() {
		const { data, onChange, teamMembers } = this.props;
		const { memberSearch, dropdownOpen } = this.state;
		const selectedIds = data.notifyTeamMembers || [];

		const selectedMembers = (teamMembers || []).filter((m) => selectedIds.includes(m._id));

		const filteredMembers = (teamMembers || []).filter((m) => {
			if (selectedIds.includes(m._id)) return false;
			if (!memberSearch.trim()) return true;
			const q = memberSearch.toLowerCase();
			return (
				(m.firstName && m.firstName.toLowerCase().includes(q)) ||
				(m.lastName && m.lastName.toLowerCase().includes(q)) ||
				(m.emailAddress && m.emailAddress.toLowerCase().includes(q))
			);
		});

		return (
			<div className="rfp-step-content">
				<h1 className="rfp-step-title">Contract Signee</h1>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Client / Company Name <span className="rfp-required-mark">*</span></label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.contractCompanyName || ''}
						onChange={(e) => onChange('contractCompanyName', e.target.value)}
						placeholder="Enter client or company name"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Primary Contact Name</label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.contractContactName || ''}
						onChange={(e) => onChange('contractContactName', e.target.value)}
						placeholder="Full name"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Contact Email</label>
					<input
						className="rfp-text-input"
						type="email"
						value={data.contractEmail || ''}
						onChange={(e) => onChange('contractEmail', e.target.value)}
						placeholder="email@company.com"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Contact Phone</label>
					<input
						className="rfp-text-input"
						type="tel"
						value={data.contractPhone || ''}
						onChange={(e) => onChange('contractPhone', e.target.value)}
						placeholder="+1 (555) 000-0000"
					/>
					<div className="rfp-input-underline" />
				</div>

				<div className="rfp-field-group">
					<label className="rfp-field-label">Contract Signer Location</label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.contractSignerLocation || ''}
						onChange={(e) => onChange('contractSignerLocation', e.target.value)}
						placeholder="Dallas, TX"
					/>
					<div className="rfp-input-underline" />
				</div>

				{/* Team Members */}
				<h1 className="rfp-step-title rfp-section-title">Team Members</h1>
				<div className="rfp-field-group">
					<label className="rfp-field-label">Notify Team Members</label>
					<p className="rfp-field-description">
						Search and select team members to notify by email when this RFP is submitted.
					</p>

					{/* Selected member chips */}
					{selectedMembers.length > 0 && (
						<div className="rfp-member-chips">
							{selectedMembers.map((m) => (
								<span key={m._id} className="rfp-member-chip">
									<span className="rfp-member-chip-avatar">
										{m.firstName ? m.firstName.charAt(0).toUpperCase() : '?'}
									</span>
									<span className="rfp-member-chip-name">
										{m.firstName} {m.lastName}
									</span>
									<button
										type="button"
										className="rfp-member-chip-remove"
										onClick={() => this.removeMember(m._id)}
									>
										<i className="las la-times" />
									</button>
								</span>
							))}
						</div>
					)}

					{/* Search input + dropdown */}
					<div className="rfp-member-search-wrap" ref={this.dropdownRef}>
						<div className="rfp-member-search-input-row" ref={this.searchRef}>
							<i className="las la-search rfp-member-search-icon" />
							<input
								className="rfp-member-search-input"
								type="text"
								value={memberSearch}
								placeholder="Search by name or email..."
								onChange={(e) => this.setState({ memberSearch: e.target.value, dropdownOpen: true })}
								onFocus={() => this.setState({ dropdownOpen: true })}
							/>
						</div>

						{dropdownOpen && filteredMembers.length > 0 && (
							<div className="rfp-member-dropdown">
								{filteredMembers.slice(0, 8).map((m) => (
									<div
										key={m._id}
										className="rfp-member-dropdown-item"
										onMouseDown={() => this.addMember(m)}
									>
										<div className="rfp-member-avatar-sm">
											{m.firstName ? m.firstName.charAt(0).toUpperCase() : '?'}
										</div>
										<div className="rfp-member-info">
											<span className="rfp-member-name">
												{m.firstName} {m.lastName}
											</span>
											<span className="rfp-member-email">{m.emailAddress}</span>
										</div>
									</div>
								))}
							</div>
						)}

						{dropdownOpen && memberSearch.trim() && filteredMembers.length === 0 && (
							<div className="rfp-member-dropdown">
								<div className="rfp-member-dropdown-empty">No members found.</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default ContractSigneeStep;
